import * as types from "./mutationTypes";

export default {
  [types.SET_CUSTOMERS](state, customers) {
    state.customers = customers;
  },
  [types.CLEAR_CUSTOMERS](state) {
    state.customers = null;
  },
  [types.SET_TOTAL_CUSTOMERS](state, total) {
    state.totalCustomers = total;
  },
  [types.CLEAR_TOTAL_CUSTOMERS](state) {
    state.totalCustomers = null;
  },
  [types.REMOVE_CUSTOMER](state, customerUUID) {
    state.customers = state.customers.filter((customer) => customer.uuid != customerUUID);
    state.totalCustomers -= 1;
  },
  [types.SET_NOTES](state, notes) {
    state.notes = notes;
  },
  [types.CLEAR_NOTES](state) {
    state.notes = null;
  },
  [types.ADD_NOTE](state, note) {
    state.notes.push(note);
  },
  [types.REMOVE_NOTE](state, uuid) {
    state.notes = state.notes.filter((note) => note.uuid !== uuid);
  },
  [types.SET_CUSTOMER_METADATAS](state, metadatas) {
    state.customerMetadatas = metadatas;
  },
  [types.CLEAR_CUSTOMER_METADATAS](state) {
    state.customerMetadatas = null;
  }
};
